import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from 'src/app/services/events.service';

@Component({
    selector: 'app-media-modal',
    templateUrl: './media-modal.component.html',
    styles: [],
})
export class MediaModalComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal, private eventsService: EventsService) {}

    folders: any[] = [];

    ngOnInit(): void {}

    select() {
        this.eventsService.trigger.next({ name: 'getSelectedAsset', value: null });
        this.activeModal.close();
    }
}
